export interface CheckCanAccessDiscoverMoreParams {
  PAY_4551_DISCOVER_MORE_PAGE?: boolean
  isSuperuser?: boolean
}

export class CheckCanAccessDiscoverMoreUseCase {
  execute = ({
    PAY_4551_DISCOVER_MORE_PAGE,
    isSuperuser,
  }: CheckCanAccessDiscoverMoreParams): boolean =>
    isSuperuser === true && PAY_4551_DISCOVER_MORE_PAGE === true
}
